'use client';

import { useTranslations } from 'next-intl';
import styles from './BackgroundGradient.module.scss';

export const BackgroundGradient = () => {
  const t = useTranslations('components.backgroundGradient');

  return (
    <span
      className={styles.wrapper}
      role="img"
      aria-label={t('backgroundGradient')}
      aria-hidden="true"
    >
      <span className={styles.gradient} />
    </span>
  );
};
